import { render, staticRenderFns } from "./RowsForm.vue?vue&type=template&id=afab6b58&scoped=true"
import script from "./RowsForm.vue?vue&type=script&lang=js"
export * from "./RowsForm.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./RowsForm.vue?vue&type=style&index=1&id=afab6b58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afab6b58",
  null
  
)

export default component.exports